<template>
    <div class="w100 bgGrey">
        <article class="wContent center bgWhite p20" style="box-sizing: border-box;">
            <el-row :gutter="20">
                <el-col :span="12">
                    <div class="grid-content">
                        <div class="sitemap-box radius mw-modular-box bgWhite">
                            <h3 class="font16 fontNormal fontBold">资讯</h3>
                           
                            <div class="w100 p20">
                                <div class="sitemap-text-box" v-for="(item, index) in inforTab_list" :key="index">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['资讯']" class="font14 inlineBlock vMid fontLight">{{ item.type_name }}</router-link>
                                </div>
                            </div>
                        </div>

                        <div class="sitemap-box radius mw-modular-box bgWhite">
                            <h3 class="font16 fontNormal fontBold">价格指数</h3>
                            <div class="w100 p20">
                                <div class="sitemap-text-box">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['价格指数']" class="font14 inlineBlock vMid fontLight">唐宋钢坯价格指数</router-link>
                                </div>
                                <div class="sitemap-text-box">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['价格指数']" class="font14 inlineBlock vMid fontLight">唐宋带钢价格指数</router-link>
                                </div>
                                <div class="sitemap-text-box">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['价格指数']" class="font14 inlineBlock vMid fontLight">唐宋进口矿价格指数</router-link>
                                </div>
                                <div class="sitemap-text-box">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['价格指数']" class="font14 inlineBlock vMid fontLight">唐宋焦炭价格指数</router-link>
                                </div>
								<div class="sitemap-text-box">
								    <svg class="icon" aria-hidden="true">
								        <use xlink:href="#icon-ETH"></use>
								    </svg>
								    <router-link :to="router['价格指数']" class="font14 inlineBlock vMid fontLight">晋南钢铁价格</router-link>
								</div>
                            </div>
                        </div>

                        <div class="sitemap-box radius mw-modular-box bgWhite">
                            <h3 class="font16 fontNormal fontBold">报价</h3>
                           
                            <div class="w100 p20">
                                <div class="sitemap-text-box" v-for="(item, index) in productTree_list" :key="index" style="width: 24%;">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['报价'] + '?type=' + item.groupPid" class="font14 inlineBlock vMid fontLight">{{ item.productName }}</router-link>
                                </div>
                                <div class="sitemap-text-box" style="width: 24%;">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['报价']" class="font14 inlineBlock vMid fontLight">其他</router-link>
                                </div>
                                <div class="sitemap-text-box" style="width: 24%;" v-show="showCustomized">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="customized" class="font14 inlineBlock vMid fontLight">定制报价信息</router-link>
                                </div>
                            </div>
                        </div>

                        <div class="sitemap-box radius mw-modular-box bgWhite">
                            <h3 class="font16 fontNormal fontBold">钢坯调期</h3>
                           
                            <div class="w100 p20">
                                <div class="sitemap-text-box">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['钢坯调期']" class="font14 inlineBlock vMid fontLight">服务内容</router-link>
                                </div>
                                <div class="sitemap-text-box">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['钢坯调期']" class="font14 inlineBlock vMid fontLight">获取联系</router-link>
                                </div>
                            </div>
                        </div>

                        <div class="sitemap-box radius mw-modular-box bgWhite">
                            <h3 class="font16 fontNormal fontBold">企业报价</h3>
                           
                            <div class="w100 p20">
                                <div class="sitemap-text-box" v-for="(item, index) in varietiesList" :key="index">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['企业报价'] + '?type=' + item.id" class="font14 inlineBlock vMid fontLight">{{ item.name }}</router-link>
                                </div>
                            </div>
                        </div>

                        <div class="sitemap-box radius mw-modular-box bgWhite">
                            <h3 class="font16 fontNormal fontBold">其他</h3>
                           
                            <div class="w100 p20">
                                <div class="sitemap-text-box">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['关于我们']" class="font14 inlineBlock vMid fontLight">关于我们</router-link>
                                </div>
                                <div class="sitemap-text-box">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['意见反馈']" class="font14 inlineBlock vMid fontLight">意见反馈</router-link>
                                </div>
                                <div class="sitemap-text-box" v-show="showSelfPage">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="selfPage" class="font14 inlineBlock vMid fontLight">会员中心</router-link>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="grid-content">
                        <div class="sitemap-box radius mw-modular-box bgWhite">
                            <h3 class="font16 fontNormal fontBold">研报</h3>
                            <div class="w100 p20">
                                <div class="sitemap-text-box" v-for="(item, index) in report_list" :key="index" style="width: 49%">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['研报']" class="font14 inlineBlock vMid fontLight">{{ item.sortName }}</router-link>
                                </div>
                            </div>
                        </div>

                        <div class="sitemap-box radius mw-modular-box bgWhite">
                            <h3 class="font16 fontNormal fontBold">基准价</h3>
                            <div class="w100 p20">
                                <div class="sitemap-text-box" v-for="(item, index) in index_list" :key="index">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['基准价'] + '?tag=' + (item.tag == 'MJ' ? item.tag + '_' + item.type : item.tag)" class="font14 inlineBlock vMid fontLight">{{ item.basePriceName.substr(0, item.basePriceName.indexOf('全')) }}</router-link>
                                </div>
                            </div>
                        </div>

                        <div class="sitemap-box radius mw-modular-box bgWhite">
                            <h3 class="font16 fontNormal fontBold">期现</h3>
                           
                            <div class="w100 p20">
                                <div class="sitemap-text-box">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['期现']" class="font14 inlineBlock vMid fontLight">期现</router-link>
                                </div>
                                <div class="sitemap-text-box">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['期现']" class="font14 inlineBlock vMid fontLight">服务内容</router-link>
                                </div>
                                <div class="sitemap-text-box">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['期现']" class="font14 inlineBlock vMid fontLight">服务特色</router-link>
                                </div>
                                <div class="sitemap-text-box">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['期现']" class="font14 inlineBlock vMid fontLight">获取联系</router-link>
                                </div>
                            </div>
                        </div>

                        <div class="sitemap-box radius mw-modular-box bgWhite">
                            <h3 class="font16 fontNormal fontBold">商情</h3>
                           
                            <div class="w100 p20">
                                <div class="sitemap-text-box" v-for="(item, index) in varietiesList" :key="index">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['商情'] + '?type=' + item.id" class="font14 inlineBlock vMid fontLight">{{ item.name }}</router-link>
                                </div>
                            </div>
                        </div>

                        <div class="sitemap-box radius mw-modular-box bgWhite" style="height: 194px;">
                            <h3 class="font16 fontNormal fontBold">服务体系</h3>
                           
                            <div class="w100 p20">
                                <div class="sitemap-text-box">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['服务体系']" class="font14 inlineBlock vMid fontLight">信息数据服务</router-link>
                                </div>
                                <div class="sitemap-text-box">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['服务体系']" class="font14 inlineBlock vMid fontLight">大数据项目服务</router-link>
                                </div>
                                <div class="sitemap-text-box">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['服务体系']" class="font14 inlineBlock vMid fontLight">供应链服务</router-link>
                                </div>
                                <div class="sitemap-text-box">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['服务体系']" class="font14 inlineBlock vMid fontLight">期货咨询服务</router-link>
                                </div>
                                <div class="sitemap-text-box">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-ETH"></use>
                                    </svg>
                                    <router-link :to="router['服务体系']" class="font14 inlineBlock vMid fontLight">多元集成服务</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </article>
        <ConcatsControl></ConcatsControl>
    </div>
</template>

<script>
import $ from 'jquery'
import { baseUrl, navigationUrl } from '../../assets/js/common'
import ConcatsControl from '../../templates/concatsControl'
export default {
    name: 'SiteMap',
    components: {ConcatsControl},
    data () {
        return {
            varietiesList: [],
            router: navigationUrl,
            inforTab_list: [],
            productTree_list: [],
            report_list: [],
            index_list: [],
            showSelfPage: false,
            showCustomized: false,
            selfPage: '',
            customized: ''
        }
    },
    mounted () {
        // 初始化内容
        this.findNewsClassify();
        this.getProductTreeList();
        this.findReportSort();
        this.findAllProductTag();
        this.getUserInfoAll();
        this.findAllVarieties();
    },
    methods: {
        //页面操作
        getUserInfoAll () {
            const self = this;
            const token_cyw = this.$cookies.get('token_cyw');
            if (token_cyw) {
                self.$get(`${baseUrl.business}/api/user/userByToken/${token_cyw}`, {}).then(res_1 => {
                    if (res_1.status == 200) {
                        const url = self.router['会员中心'];
                        self.selfPage =  url;
                        self.showSelfPage = true;
                        self.customized = self.router['报价定制'];
                        self.showCustomized = true;
                    } else {
                        self.showSelfPage = false;
                        self.showCustomized = false;
                    }
                }).catch(err_1 => {
                    self.showSelfPage = false;
                    self.showCustomized = false;
                })
            } else {
                self.showSelfPage = false;
                self.showCustomized = false;

            }
        },
        // 获取企业报价全部产品
        findAllVarieties () {
            const self = this;
            self.$get(`${baseUrl.business}/api/varieties/findAll`, {}).then(res => {
                if (res.status == 200) {
                    self.varietiesList = res.data;
                } else {
                    self.$message.error(res.msg);
                }
            })
        },
        // 获取资讯二级分类
        findNewsClassify () {
            const self = this;
            $.ajax({
                url: `${baseUrl.service}/api_v3/news_classify?pagenum=1&pernum=99`,
                data: {},
                type: 'get',
                dataType: 'json',
                success: (res) => {
                    if (res.code == 'ok') {
                        self.inforTab_list = [];
                        res.data.forEach((item, index) => {
                            if (item.the_level == 1 && item.is_valid == 'Y') {
                                self.inforTab_list.push(item);
                            }
                        })
                    } else {
                        self.$message.error(res.message);
                    }
                },
                error: () => {
                    self.$message.error('未获取到资讯分类信息')
                }
            })
        },
        // 查询全部调价分类
        getProductTreeList () {
            const self = this;
            self.$get(`${baseUrl.crm}/business/cyw/openapi/getProductTreeList.json`, {}).then(res => {
                if (res.code == 200) {
                    self.productTree_list = res.data.splice(0, 9);
                } else {
                    self.$message.error('查询分类信息失败');
                }
            }).catch(error => {
                self.$message.error('查询分类信息失败')
            })
        },
        // 研报二级菜单
        findReportSort () {
            const self = this;
            self.$get(`${baseUrl.online}/industria/reportSort/findReportSortByUserFormat`, {}).then(res => {
                if (res.code == 0) {
                    self.report_list = res.data;
                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                self.$message.error('未获取到分类信息')
            })
        },
        // 获取基准价所有大产品标识
        findAllProductTag () {
            const self = this;
            self.$get(`${baseUrl.online}/industriaBasePrise/findIndexTopList`, {}).then(res => {
                if (res.code == 0) {
                    self.index_list = res.data;
                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                self.$message.error('未获取到分类信息')
            })
        },
    },
}
</script>

<style scoped>
    
    .sitemap-box { border: 1px solid #666; }
    .sitemap-box > h3 { height: 45px; line-height: 45px; border-bottom: 1px solid #ccc; padding-left: 20px; }
    .sitemap-box > div > div { width: 33%; display: inline-block; }
    .sitemap-text-box { line-height: 40px }
    .sitemap-text-box a { padding-left: 10px; }
</style>